/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFreeNightCreditRequest
 */
export interface UpdateFreeNightCreditRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeNightCreditRequest
     */
    loyaltyAccountId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeNightCreditRequest
     */
    programName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeNightCreditRequest
     */
    creditType?: UpdateFreeNightCreditRequestCreditTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateFreeNightCreditRequest
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateFreeNightCreditRequest
     */
    remainingCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof UpdateFreeNightCreditRequest
     */
    expirationDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof UpdateFreeNightCreditRequest
     */
    pointsCap?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFreeNightCreditRequest
     */
    categoryCap?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFreeNightCreditRequest
     */
    topUpAllowed?: boolean;
    /**
     * Whether expiration reminders fire for this credit (GON-5964).
     * @type {boolean}
     * @memberof UpdateFreeNightCreditRequest
     */
    remindersEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFreeNightCreditRequest
     */
    notes?: string | null;
}


/**
 * @export
 */
export const UpdateFreeNightCreditRequestCreditTypeEnum = {
    MarriottFreeNight: 'marriott_free_night',
    HiltonFreeNight: 'hilton_free_night',
    HyattFreeNight: 'hyatt_free_night',
    IhgFreeNight: 'ihg_free_night',
    WyndhamFreeNight: 'wyndham_free_night'
} as const;
export type UpdateFreeNightCreditRequestCreditTypeEnum = typeof UpdateFreeNightCreditRequestCreditTypeEnum[keyof typeof UpdateFreeNightCreditRequestCreditTypeEnum];


/**
 * Check if a given object implements the UpdateFreeNightCreditRequest interface.
 */
export function instanceOfUpdateFreeNightCreditRequest(value: object): value is UpdateFreeNightCreditRequest {
    return true;
}

export function UpdateFreeNightCreditRequestFromJSON(json: any): UpdateFreeNightCreditRequest {
    return UpdateFreeNightCreditRequestFromJSONTyped(json, false);
}

export function UpdateFreeNightCreditRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFreeNightCreditRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'loyaltyAccountId': json['loyalty_account_id'] == null ? undefined : json['loyalty_account_id'],
        'programName': json['program_name'] == null ? undefined : json['program_name'],
        'creditType': json['credit_type'] == null ? undefined : json['credit_type'],
        'totalCount': json['total_count'] == null ? undefined : json['total_count'],
        'remainingCount': json['remaining_count'] == null ? undefined : json['remaining_count'],
        'expirationDate': json['expiration_date'] == null ? undefined : (new Date(json['expiration_date'])),
        'pointsCap': json['points_cap'] == null ? undefined : json['points_cap'],
        'categoryCap': json['category_cap'] == null ? undefined : json['category_cap'],
        'topUpAllowed': json['top_up_allowed'] == null ? undefined : json['top_up_allowed'],
        'remindersEnabled': json['reminders_enabled'] == null ? undefined : json['reminders_enabled'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateFreeNightCreditRequestToJSON(json: any): UpdateFreeNightCreditRequest {
    return UpdateFreeNightCreditRequestToJSONTyped(json, false);
}

export function UpdateFreeNightCreditRequestToJSONTyped(value?: UpdateFreeNightCreditRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'loyalty_account_id': value['loyaltyAccountId'],
        'program_name': value['programName'],
        'credit_type': value['creditType'],
        'total_count': value['totalCount'],
        'remaining_count': value['remainingCount'],
        'expiration_date': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString().substring(0,10),
        'points_cap': value['pointsCap'],
        'category_cap': value['categoryCap'],
        'top_up_allowed': value['topUpAllowed'],
        'reminders_enabled': value['remindersEnabled'],
        'notes': value['notes'],
    };
}

